module.exports = window.wp.deprecated;